/**
 * True when the search text is found in the person's name, e-mail, phone or message. An empty search
 * matches everyone. Case is ignored.
 */
export const matchesReplySearch = (reply: any, searchText: string): boolean => {
    const search = searchText.trim().toLowerCase();

    if (!search) {
        return true;
    }

    return [reply?.customerName, reply?.customerEmail, reply?.customerPhone, reply?.customerAnswer]
        .some(value => (value ?? "").toString().toLowerCase().includes(search));
};

/** Sorts names in Swedish order, so å, ä and ö come last. */
export const compareNames = (a?: string, b?: string): number => {
    return (a ?? "").localeCompare(b ?? "", "sv", { sensitivity: "base" });
};
